import React from 'react';
import { Trans } from 'react-i18next';
import { CHAINS_LIST as chainList, Chain } from '@debank/common/dist/index-mainsite';

import * as ChainLogo from '@/assets/debank';
import { request } from './request';

type LocalChain = Pick<
  Chain,
  'name' | 'id' | 'serverId' | 'scanLink' | 'hex' | 'nativeTokenSymbol' | 'logo'
> & {
  sortIdx?: number;
  is_support_history?: boolean;
};

export const CHAIN_ID_ALL = {
  name: <Trans i18nKey="Utils.all-chain"></Trans>,
  logo: ChainLogo.IconChainAll,
  serverId: '',
};

export const CHAINS_DICT = chainList.reduce(
  (m, n, i) => ({
    ...m,
    [n.serverId]: {
      ...n,
      sortIdx: i,
    },
  }),
  {} as Record<string, LocalChain>,
);

export function getExplorerLink(chain: string, id: string) {
  return CHAINS_DICT[chain]?.scanLink.includes('_s_')
    ? CHAINS_DICT[chain]?.scanLink.replace(/_s_/, id)
    : CHAINS_DICT[chain]?.scanLink + `/tx/${id}`;
}

// 根据 CHAINS_LIST 来排序, chains 为 id 顺序，有时候后端返回是乱序的
export function sortChain(chains: string[] = []) {
  return [...chains].sort((m, n) => CHAINS_DICT[m].sortIdx! - CHAINS_DICT[n].sortIdx!);
}

const CHAINS_LIST: LocalChain[] = chainList.slice();

export type RemoteChain = {
  block_interval: number;
  eip_1559: boolean;
  explorer_host: string;
  id: string;
  is_support_archive: boolean;
  is_support_history: boolean;
  logo_url: string;
  name: string;
  network_id: number;
  prefix: string;
  start_at: string;
  svg_logo_url: string;
  token_id: string;
  token_symbol: string;
  white_logo_url: string;
  wrapped: string;
};

const overwriteChain = (chain: RemoteChain, i = CHAINS_LIST.length) => {
  CHAINS_DICT[chain.id] = {
    id: chain.network_id,
    name: chain.name,
    hex: `0x${chain.network_id.toString(16)}`,
    serverId: chain.id,
    nativeTokenSymbol: chain.token_symbol,
    scanLink: chain.explorer_host,
    logo: chain.logo_url,
    is_support_history: chain.is_support_history,
    sortIdx: i,
  };

  const idx = CHAINS_LIST.findIndex(x => x.id === chain.network_id);

  if (idx > -1) {
    CHAINS_LIST[idx] = CHAINS_DICT[chain.id];
  } else {
    CHAINS_LIST.push(CHAINS_DICT[chain.id]);
  }
};

export const loadRemoteChains = async () => {
  try {
    const { chains } = await request.get<{ chains: RemoteChain[] }>('/chain/list');
    // 移除本地链
    CHAINS_LIST.length = 0;

    let i = 0;
    for (const chain of chains) {
      overwriteChain(chain, i);
      i++;
    }

    Object.keys(CHAINS_DICT).forEach(x => {
      if (chains.every(c => c.id !== x)) {
        delete CHAINS_DICT[x];
      }
    });
    console.log('chain loaded', CHAINS_LIST.length);
  } catch (error) {
    console.log('load chain error', error);
  }
};

export const setChains = (chains?: RemoteChain | RemoteChain[]) => {
  if (!chains) {
    return;
  }

  const _chains = Array.isArray(chains) ? chains : [chains];

  for (const chain of _chains) {
    overwriteChain(chain, CHAINS_LIST.length);
  }
};

export { CHAINS_LIST };
